import { render, staticRenderFns } from "./button-card.vue?vue&type=template&id=5a8c69de&scoped=true"
import script from "./button-card.vue?vue&type=script&lang=js"
export * from "./button-card.vue?vue&type=script&lang=js"
import style0 from "./button-card.vue?vue&type=style&index=0&id=5a8c69de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8c69de",
  null
  
)

export default component.exports